
<template>
	<div>
		<compWrapper :title="$t('global.common.base_information',{defaultValue:'基本信息'})" theme="primary">
			<vFormItem :label="$t('fbb.fedex.order_num',{defaultValue:'销售出库订单号'})" label-width="120">
				<vInput v-model="formData.orderNo" readonly class="width-30per margin-top-15">
					<vIcon
						type="search"
						center
						slot="suffix"
						style="padding:6px;pointer-events: initial;"
						size="18"
						@click.native="show=true"
					/>
				</vInput>
			</vFormItem>
			<footer class="text-center">
				<vButton class="margin-right-20" theme="primary" @click="calculate">{{$t('fbb.fedex.calc_measure',{defaultValue:'开始测算'})}}</vButton>
				<vButton theme="error" @click="reset">{{$t('global.common.btn_reset',{defaultValue:'重置'})}}</vButton>
			</footer>
		</compWrapper>
		<compWrapper title="测算结果" theme="info">
			<vAlert class="margin-15" theme="warning">
				{{$t('fbb.fedex.calc_bigtip',{defaultValue:'特别说明：测算的费用包含部分附加费,如：燃油附加费、地址附加费、超长超重附加费等；FedEx是账单制度，签收包裹后会根据官方实际账单产生额外费用，如：成人签字附加费、地址更改费等，实际费用以账单为准，计费重量是包裹毛重和体积重两者取大者，使用FedEX Ground、FedEX Home Delivery两种服务时，若加收Oversize费用时，若包裹计费重量不足90lb时，按90lb计算'})}}
			</vAlert>
			<compCalc :data="calcList"></compCalc>
		</compWrapper>
		<vLoading size="large" transfer :loading="loading"></vLoading>
		<vModal v-model="show" :label="$t('fbb.fedex.chose_ordernum',{defaultValue:'请选择销售出库订单号'})" width="900" :showFooter="false">
			<compTableList v-bind="handleOrderList"/>
		</vModal>
	</div>
</template>

<script>
// import { mapState, mapGetters } from 'vuex';
import { HttpOrderCalc, HttpOrderList } from "@/service/fedex";
import compCalc from "./calc";
export default {
	components: {
		compCalc,
		compWrapper: () => import("@components/templates/wrapper"),
		compFormEdit: () => import("@components/templates/formedit"),
		compTableList: () => import("@components/templates/tablelist"),
	},
	data() {
		return {
			loading: false,
			show: false,
			formData: {

			},
			calcList: [],
		};
	},
	computed: {    
		getOrderStatus(){
			return {
				'pending':this.$t('erp.b2c.orderstatus_pending',{defaultValue:'未支付'}),
				'unshipped':this.$t('erp.b2c.orderstatus_unshipped',{defaultValue:'未发货'}),
				'approved':this.$t('erp.b2c.orderstatus_approved',{defaultValue:'已审核'}),
				'assigned':this.$t('erp.b2c.orderstatus_assigned',{defaultValue:'已分配'}),
                'picked':this.$t('erp.b2c.orderstatus_picked',{defaultValue:'已配货'}),
                'shipped':this.$t('erp.b2c.orderstatus_shipped',{defaultValue:'已发货'}),
                'canceled':this.$t('erp.b2c.orderstatus_canceled',{defaultValue:'已取消'}),
                'refunded':this.$t('erp.b2c.orderstatus_refunded',{defaultValue:'已退款'}),
			}
		},
		orderColumns() {
			return [
				{
					title: this.$t('fbb.adjustment.list_sale',{defaultValue:'销售订单'}),
					key: "id",
				},
				{
					title: this.$t('erp.b2c.product_orgwarehouse',{defaultValue:'仓库'}),
					key: "orgWarehouseCode",
				},
				{
					title: this.$t('erp.b2c.search_orderstatus',{defaultValue:'订单状态'}),
					key: "orderStatus",
					render:(h,{row})=>{
						return this.getOrderStatus[row.orderStatus]||"";
					}
				},
				{
					title: this.$t('global.common.operation',{defaultValue:'操作'}),
					width: 120,
					align: "center",
					render: (h, { row }) => {
						return <vButton theme="primary" nativeOnClick={this.getOrderInfo.bind(this, row)}>{this.$t('fbb.inbound.choose',{defaultValue:'选择'})}</vButton>
					}
				}
			]
		},
		handleOrderList() {
			return {
				columns: this.orderColumns,
				Searchs: {
					show: true,
					style: "border:none;",
					labelWidth: "auto",
                    align: "left",
                },
                startUp: true,
                initFormData: {
					search:{
						'IN_orderStatus':['assigned','picked','shipped'],
					}
				},
				SearchsData: [
					{
						label: this.$t('fbb.fedex.order_num',{defaultValue:'销售出库订单号'}),
						tag: "vInput",
						key: "EQ_orderNo",
						show: true
					},
				],
				ajaxRequest: HttpOrderList,
			};
		},
	},
	methods: {
		reset() {
			this.formData = {};
			this.calcList = [];
			this.$refs.formbase.resetValidate();
		},
		getOrderInfo(data) {
			this.show=false;
			this.formData.orderNo = data.id;
		},
		async calculate() {
			if (!this.formData.orderNo) return;
			this.loading = true;
			HttpOrderCalc(this.formData).then(
				res => {
					this.calcList = res.data || [];
					this.loading = false;
				},
				err => {
					this.loading = false;
					this.$VMessage.error(err.message);
				}
			);
		}
	}
};
</script>
